<template>
  <div class="drawer-notice-panel">
    <div v-if="noticeList && noticeList.length > 0">
      <div class="notice-element" v-for="notice in noticeList" :key="notice.id">
        <div class="notice-element-header">
          <span class="title" :title="notice.title">{{ notice.title }}</span>
          <div class="flag">
            <i v-if="notice.star" class="el-icon-star-on"></i>
            <i v-if="!notice.read" class="el-icon-info"></i>
          </div>
          <div class="tools">
            <el-tooltip v-if="!notice.read" content="标记已读" :open-delay="tipsDeploy" placement="top">
              <i @click="updateNoticeStatus(notice, 'read')" class="el-icon-check"></i>
            </el-tooltip>
            <el-tooltip :content="notice.star ? '取消星标' : '星标'" :open-delay="tipsDeploy" placement="top">
              <i @click="updateNoticeStatus(notice, notice.star ? 'unstar' : 'star')" :class="[notice.star ? 'el-icon-star-on' : 'el-icon-star-off']"></i>
            </el-tooltip>
            <el-tooltip content="删除" :open-delay="tipsDeploy" placement="top">
              <i @click="updateNoticeStatus(notice, 'delete')" class="el-icon-close"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="notice-element-body">
          <p v-html="replaceExp(notice.content)"></p>
        </div>
        <span class="time">{{ formatDate(notice.createDate) }}</span>
      </div>
      <div class="load-more" v-show="hasMore" @click="handleLoadMore">
        <i v-if="loadingMore" class="el-icon-loading"></i>
        <i v-else class="el-icon-d-arrow-right"></i>
      </div>
    </div>
    <div v-else class="no-notice">
      无通知信息额~
    </div>
  </div>
</template>

<script>
  import util from '../../libs/util'

  export default {
    name: 'notice-panel',
    props: {
      noticeList: {
        type: Array,
        default() {
          return []
        }
      },
      hasMore: {
        type: Boolean,
        default: false
      },
      loadingMore: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        tipsDeploy: 800
      }
    },
    methods: {
      formatDate(d) {
        return util.formatDate(new Date(d), 'yyyy-MM-dd HH:mm:ss')
      },
      updateNoticeStatus(notice, status) {
        this.$emit('notice-status-change', notice, status)
      },
      handleLoadMore() {
        if (!this.loadingMore) {
          this.$emit('load-more')
        }
      },
      replaceExp(target) {
        // 替换内容中的超链接占位符
        // if (new RegExp(NOTICE_CONSTANT.urlRegStr).test(target)) {
        //   let match = target.match(NOTICE_CONSTANT.urlRegStr)
        //   for (let i = 0; i < match.length; i++) {
        //     // 拿到匹配到的字符串
        //     let m = match[i]
        //     let matchArr = m.replace('{a:', '').replace('}', '').split(':')
        //     let html = '<a href="' + util.baseUrl + matchArr[0] + '" class="downLink" target="_blank">' + matchArr[1] + '</a>'
        //     target = target.replace(m, html)
        //   }
        // }
        return target
      }
    }
  }
</script>

<style lang="scss">
  .drawer-notice-panel {
    .no-notice {
      height: 100%;
      text-align: center;
      margin-top: 50%;
      color: #909399;
    }
    .notice-element {
      margin: 0;
      padding: 10px 10px 18px;
      min-height: 98px;
      border-bottom: 1px solid #e2e2e2;
      position: relative;

      &:hover {
        background-color: #f5f5f5;
        .notice-element-header {
          .flag {
            display: none;
          }
          .tools {
            display: flex;
          }
        }
      }

      .notice-element-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 20px;

        .title {
          flex: 1 1 auto;
          line-height: 20px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: 600;
        }
        .flag {
          display: flex;
          flex: 0 0 auto;

          i {
            font-size: 16px;
            line-height: 20px;
            margin-right: 3px;
            &.el-icon-info {
              color: #1b87ff;
            }
            &.el-icon-star-on {
              color: #ffac38;
            }
          }
        }
        .tools {
          display: none;
          flex: 0 0 auto;

          i {
            font-size: 18px;
            line-height: 20px;
            cursor: pointer;
            color: #383838;
            margin-left: 12px;
            &.el-icon-star-on {
              color: #666666;
            }
          }
          i:hover {
            color: #3da8f5;
          }
        }
      }
      .notice-element-body {
        width: 100%;
        padding-top: 2px;
        p {
          line-height: 20px;
        }
      }
      .time {
        position: absolute;
        right: 10px;
        bottom: 0;
        color: #82848a;
      }
    }
    .load-more {
      padding-bottom: 6px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      &:hover {
        background-color: #f5f5f5;
      }
      i {
        font-size: 20px;
        &.el-icon-d-arrow-right {
          animation: ani-load-more 1s 0s ease-in-out infinite;
        }
      }
      @keyframes ani-load-more {
        0% {
          transform: rotate(90deg) translateX(-5px);
        }

        to {
          transform: rotate(90deg) translateX(5px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/drawer-notice/notice-panel.vue